import { render, staticRenderFns } from "./StuttgartLevel.vue?vue&type=template&id=4a5288b1&scoped=true&"
import script from "./StuttgartLevel.vue?vue&type=script&lang=js&"
export * from "./StuttgartLevel.vue?vue&type=script&lang=js&"
import style0 from "./StuttgartLevel.vue?vue&type=style&index=0&id=4a5288b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5288b1",
  null
  
)

export default component.exports